// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1cHes","error":"Textarea_error__3Time","readonly":"Textarea_readonly__2SFQQ","disabled":"Textarea_disabled__3NyXU"};